export const apificate = (state) => {
  let userApi = {
    username: state.username,
    email: state.email,
    role: state.role
  }

  if (state.password) {
    userApi.password = state.password
  }

  return userApi
}
